import * as React from 'react';

import * as PermissionsHelper from '../../helpers/permissionsHelper';
import { PageTitle } from '../pages/pageTitle';

import CreateUserForm from './createUserForm';
import UsersTable from './usersTable';

// eslint-disable-next-line react/prefer-stateless-function
export class UsersPage extends React.Component {
  public render() {
    return (
      <>
        <PageTitle displayTitle="Users">
          {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.CreateUser) && <CreateUserForm />}
        </PageTitle>
        {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.GetUsers) && <UsersTable />}
      </>
    );
  }
}
